import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDirecteExpenseBalanceApi } from "../../apiservice/reports";
import { getAccountBySeachApi } from "../../apiservice/setting";

export const fetchDirectExpenseBalance = createAsyncThunk(
  "directExpenseBalance/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        accId: filters?.accId || null,
        fromDate: filters?.fromDate || null,
        toDate: filters?.toDate || null,
      };
      const res = await getDirecteExpenseBalanceApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchDirectExpenseAccountsBySearch = createAsyncThunk(
  "directExpenseLedger/fetchAccountsBySearch",
  async (search, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: search.trim(),
        search: true,
        multiType: ["direct_expense"],
      });
      return (res.data || []).map((c) => ({
        sale_id: c.acc_id,
        display_text: c.acc_name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);